import DarkModeIcon from '@mui/icons-material/DarkMode'
import LightModeIcon from '@mui/icons-material/LightMode'
import {AppBar, IconButton, Toolbar, useTheme, Button} from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import {useDispatch} from 'react-redux'
import {toggleThemeMode} from '../../Redux/gui'
import {AccountMenu} from "./AccountMenu";
import MenuBookSharpIcon from '@mui/icons-material/MenuBookSharp';
import './Header.scss'
import {ReactComponent as LogoLight} from "../../Assets/Images/ebmpapst_logo_rgb.svg";
import {ReactComponent as LogoDark} from "../../Assets/Images/ebmpapst_logo_rgb_gray_N.svg";
import {useNavigate} from "react-router-dom";
import KeyIcon from '@mui/icons-material/Key';
import UpdateSharpIcon from '@mui/icons-material/UpdateSharp';


const Header = () => {

    const dispatch = useDispatch()
    const theme = useTheme()
    const toggleMode = () => dispatch(toggleThemeMode())

    const navigate = useNavigate()

    return (
        <AppBar
            position="static"
        >
            <Toolbar>
                <IconButton onClick={() => navigate('/')}>
                    {theme.palette.mode === 'light' ? (
                        <LogoLight style={{height: '30px', marginRight: '20px'}} />
                    ) : (
                        <LogoDark style={{height: '30px', marginRight: '20px'}} />
                    )}
                </IconButton>
                <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
                    Fan Calculation API - Developer Portal
                </Typography>
                <div className={'flex flex-row gap-2'}>
                    <Button onClick={() => navigate('/')} className={'items-center'} color={theme.palette.mode === 'light' ? "secondary" : "primary"} startIcon={<KeyIcon />}>API Tokens</Button>
                    <Button onClick={() => navigate('/api-docs')} color={theme.palette.mode === 'light' ? "secondary" : "primary"} startIcon={<MenuBookSharpIcon />}>API Docs</Button>
                    <Button onClick={() => navigate('/changelog')} color={theme.palette.mode === 'light' ? "secondary" : "primary"} startIcon={<UpdateSharpIcon />}>Changelog</Button>

                    <IconButton onClick={toggleMode} className={'items-center'}>
                        {theme.palette.mode === 'light' ? (
                            <DarkModeIcon />
                        ) : (
                            <LightModeIcon />
                        )}
                    </IconButton>
                        <AccountMenu />
                </div>
            </Toolbar>
        </AppBar>
    )
}

export { Header }